import { call, put, takeEvery } from "redux-saga/effects";
import { handleAuthSuccess, handleLoginSubmit, handleAuthError } from "./actions";
import { auth } from "../../../utils/api";

function* authenticate(action) {
  const response = yield call(auth, {...action.payload});
  console.log('======', response.success)
  console.log('======', response.token)
  if (response.success === true) {
    yield put(handleAuthSuccess(response.token));
  }else{
    yield put(handleAuthError("Неверные данные для входа"));
  }
}

export function* authSaga() {
  yield takeEvery(handleLoginSubmit, authenticate);
}
